// app/javascript/controllers/ats_outreach_controller.js
//
// Outreach Message panel. Per-resume endpoints need the selected resume id,
// pushed by the coordinator via resumeIdValue. Real API (legacy 454-492):
//   POST  /api/v1/ats_optimizer/resumes/:id/generate-outreach -> { content }
//   PATCH /api/v1/ats_optimizer/resumes/:id/outreach-message  { content }
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "status"]
  static values = { resumeId: String }

  // Called by the coordinator after Optimize Match (payload.outreach_message).
  apply(payload) {
    if (payload?.outreach_message == null) return
    this.textareaTarget.value = payload.outreach_message
    this.syncPreview()
  }

  // Preview pane is outside this controller's subtree — dispatch to coordinator.
  syncPreview() {
    this.dispatch("outreach-changed", {
      detail: { text: this.textareaTarget.value },
      prefix: "ats-optimizer"
    })
  }

  async generate() {
    if (!this.resumeIdValue) return this.#status("Select a resume first")
    this.#status("Generating outreach message...")
    try {
      const data = await this.#json(
        `/api/v1/ats_optimizer/resumes/${encodeURIComponent(this.resumeIdValue)}/generate-outreach`,
        "POST", {}
      )
      this.textareaTarget.value = data.content || ""
      this.syncPreview()
      this.#status("Outreach message generated")
    } catch (e) {
      this.#status(`Generate failed: ${e.message}`)
    }
  }

  async save() {
    if (!this.resumeIdValue) return this.#status("Select a resume first")
    try {
      await this.#json(
        `/api/v1/ats_optimizer/resumes/${encodeURIComponent(this.resumeIdValue)}/outreach-message`,
        "PATCH", { content: this.textareaTarget.value }
      )
      this.#status("Outreach message saved")
    } catch (e) {
      this.#status(`Save failed: ${e.message}`)
    }
  }

  async #json(url, method, body) {
    const r = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content
      },
      body: JSON.stringify(body || {})
    })
    if (!r.ok) throw new Error(`HTTP ${r.status}`)
    return r.json().catch(() => ({}))
  }

  #status(msg) { if (this.hasStatusTarget) this.statusTarget.textContent = msg }
}
